/**
 * Edit Document Requirement Page
 */

import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AdminPageLayout, Section, Card } from '../../components';
import DocumentRequirementConfigurator from '../../components/admin/DocumentRequirementConfigurator';
import documentRequirementsService from '../../services/documentRequirementsService';
import apiService from '../../services/api';

const EditDocumentRequirement = () => {
  const navigate = useNavigate();
  const { requirement_id } = useParams();
  const [clubData, setClubData] = useState(null);
  const [requirement, setRequirement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadData();
  }, [requirement_id]);

  const loadData = async () => {
    try {
      setLoading(true);

      // Load club data
      const userInfo = await apiService.getCurrentUser();
      const club_id = userInfo.club_id;

      if (!club_id) {
        setError('Club information not found');
        return;
      }

      const clubResponse = await apiService.get('/api/clubs/public/club-info');
      setClubData({
        id: club_id,
        name: clubResponse.name || clubResponse.display_name || 'Club Name',
        club_id: club_id
      });

      // Load requirement data
      const requirementData = await documentRequirementsService.getRequirement(requirement_id);
      setRequirement(requirementData);
    } catch (err) {
      console.error('Error loading data:', err);
      setError('Failed to load requirement data');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    navigate('/admin/documents/requirements');
  };

  const handleCancel = () => {
    navigate('/admin/documents/requirements');
  };

  if (loading) {
    return (
      <AdminPageLayout
        title="EDIT DOCUMENT REQUIREMENT"
        subtitle="Update automatic document assignment rules"
        backPath="/admin/documents/requirements"
        backLabel="← Back to Requirements"
        maxWidth="1400px"
      >
        <div style={{ padding: '4rem', textAlign: 'center', opacity: 0.6 }}>
          Loading requirement...
        </div>
      </AdminPageLayout>
    );
  }

  if (error) {
    return (
      <AdminPageLayout
        title="EDIT DOCUMENT REQUIREMENT"
        subtitle="Error loading requirement"
        backPath="/admin/documents/requirements"
        backLabel="← Back to Requirements"
        maxWidth="1400px"
      >
        <Section title="ERROR">
          <Card level={1} variant="error">
            <div style={{ padding: '2rem', textAlign: 'center' }}>
              <p style={{ marginBottom: '2rem', opacity: 0.8 }}>{error}</p>
              <button
                onClick={() => navigate('/admin/documents/requirements')}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'var(--color-primary)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: 600
                }}
              >
                Back to Requirements
              </button>
            </div>
          </Card>
        </Section>
      </AdminPageLayout>
    );
  }

  return (
    <AdminPageLayout
      title="EDIT DOCUMENT REQUIREMENT"
      subtitle="Update automatic document assignment rules"
      backPath="/admin/documents/requirements"
      backLabel="← Back to Requirements"
      maxWidth="1400px"
    >
      <Section title="REQUIREMENT CONFIGURATION">
        <Card level={1}>
          {clubData && requirement && (
            <DocumentRequirementConfigurator
              club_id={clubData.id}
              requirement={requirement}
              onSave={handleSave}
              onCancel={handleCancel}
            />
          )}
        </Card>
      </Section>
    </AdminPageLayout>
  );
};

export default EditDocumentRequirement;
